import { trackImpression } from 'utility/Track/trackingHelper';
import { Impression } from 'utility/Track/types';

import { HotelRecommendation } from 'proto/Hotel/Recommendation/Recommendation';

import { TrackingLabels } from '../types';

export const trackData = (
    payload: HotelRecommendation[],
    trackingLabel: string
): void => {
    let count = 0;
    const impressions: Impression[] = [];
    payload.forEach((hotelItem) => {
        const { masterData, price, traveller } = hotelItem;
        count++;
        impressions.push(
            extractImpression(
                {
                    id: masterData?.id,
                    destinationLabel: masterData?.destinationLabel,
                    hotelCategory: masterData?.hotelCategory,
                    hotelName: masterData?.hotelName,
                    isHolidayHome: masterData?.isHolidayHome,
                    price: price,
                    traveller: traveller,
                },
                trackingLabel,
                count
            )
        );
    });

    trackImpression('impressionsRecommenders', {
        impressions: impressions,
    });
};

export const trackImpressionProductClick = (
    hotelItem: hotelItemTracking,
    index: number,
    label = TrackingLabels.HOTEL_RECOMMENDERS
): void => {
    trackImpression('productClick', {
        click: {
            actionField: {
                list: label,
                action: 'click',
            },
            products: [extractImpression(hotelItem, label, index + 1)],
        },
    });
};

// TODO check if tracking ist correct
const extractImpression = (
    hotelItem: hotelItemTracking,
    TrackingLabel: string,
    position: number
): Impression => {
    return {
        id:
            (hotelItem?.isHolidayHome ? 'HOLIDAYHOME_' : 'HOTEL_') +
            hotelItem?.id,
        brand: hotelItem?.hotelCategory ?? 0,
        category: hotelItem?.destinationLabel ?? '',
        quantity: hotelItem.traveller,
        price: hotelItem.price,
        name: hotelItem?.hotelName ?? '',
        list: TrackingLabel,
        position: position,
    };
};

export interface hotelItemTracking {
    id?: number;
    isHolidayHome?: boolean;
    hotelCategory?: number;
    destinationLabel?: string;
    traveller: number;
    price: number;
    hotelName?: string;
}
